import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const sessionId = m[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, { headers: { "X-Session-ID": sessionId } });
        setUser(data.user);
        window.history.replaceState({}, "", "/dashboard");
        nav(data.user.role === "admin" ? "/admin" : "/dashboard", { state: { user: data.user } });
      } catch (e) {
        nav("/login");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 to-white">
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-emerald-700 animate-spin mx-auto" />
        <div className="mt-3 text-slate-700 font-medium">Signing you in…</div>
      </div>
    </div>
  );
}
